import React, { FC, useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { UserContext } from "../contexts/UserContext";

export const NeedsOnboarding: FC = () => {
  const { user } = useContext(UserContext);

  if (user?.needsOnboarding) {
    return <Navigate to="/onboarding" replace />;
  } else {
    return <Outlet />;
  }
};
